/**
 * Date utility functions
 */

/**
 * Format a date to YYYY-MM-DD string
 */
export function formatDateToString(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Get default date range (last 3 days ending yesterday)
 */
export function getDefaultDateRange(): { from: string; to: string } {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  const threeDaysAgo = new Date(yesterday);
  threeDaysAgo.setDate(threeDaysAgo.getDate() - 2);

  return {
    from: formatDateToString(threeDaysAgo),
    to: formatDateToString(yesterday),
  };
}

/**
 * Calculate number of days between two date strings (inclusive)
 */
export function calculateDateRangeDays(from: string, to: string): number {
  const fromDate = new Date(from);
  const toDate = new Date(to);
  return Math.ceil((toDate.getTime() - fromDate.getTime()) / (1000 * 60 * 60 * 24)) + 1;
}
